import {NgcCookieConsentConfig} from 'ngx-cookieconsent';

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const {version} = require('../../package.json');
export const UTISHA_DATE_FORMATS = {
  parse: {
    dateInput: ['YYYY-MM-DD'],
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: window.location.hostname
  },
  "palette": {
    "popup": {
      "background": "#f8f5f5",
      "text": "#000000",
      "link": "#ffffff"
    },
    "button": {
      "background": "#00639a",
      "text": "#ffffff",
      "border": "transparent"
    }
  },
  theme: 'classic',
  type: 'opt-out',
  revokable: false,
  dismissOnScroll: true,
  revokeBtn: '<span></span>',
  blacklistPage: [
    '/timetable',
    /\/videos\/fullscreen\/.*/
  ] as string[]
};

